(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTrWorkOrderTypeAttributeDialogController', CustomTrWorkOrderTypeAttributeDialogController);

    CustomTrWorkOrderTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomTrWorkOrderTypeAttribute'];

    function CustomTrWorkOrderTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomTrWorkOrderTypeAttribute) {
        var vm = this;

        vm.customTrWorkOrderTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customtrWorkOrdertypeattributevalues = CustomTrWorkOrderTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues != null && vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues.length != 0) {
			vm.items = vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customTrWorkOrderTypeAttribute.id !== null) {
            	
            	 vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomTrWorkOrderTypeAttribute.update(vm.customTrWorkOrderTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomTrWorkOrderTypeAttribute.save(vm.customTrWorkOrderTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customTrWorkOrderTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-trworkorder-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
